<template>
    <transition name="fade">
        <div v-if="isOpen" id="contributor-modal" class="contributor-modal">
            <div class="modal-content relative" v-on-clickaway="closeModal">
                <InnerLoader v-if="isLoading" class="contributor-loading" />
                <div class="modal-header">
                    <div class="text-right">
                        <i
                            class="fas text-grey fa-times text-xl shadow-text-none cursor-pointer"
                            @click="closeModal"
                        ></i>
                    </div>
                </div>
                <div class="modal-body text-center">
                    <h3 class="text-2xl shadow-text-none text-center mt-0">Apply as a Contributor</h3>
                    <form @submit.prevent="submit" class="m-auto max-w-md">
                        <div class="form-group mb-3">
                            <label for="fullname" class="input-label text-black text-left text-base">Full name</label>
                            <input
                                v-model="form.fullname"
                                v-validate="'required'"
                                name="fullname"
                                type="text"
                                placeholder="Enter your full name"
                                :class="{
                                    'input input-block border-gray sm': true,
                                    'is-invalid': errors.has('fullname')
                                }"
                            />
                            <div class="invalid-feedback">
                                <span v-if="errors.has('fullname')" class="has-error shadow-text-none">{{
                                    errors.first('fullname')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="age" class="input-label text-black text-left text-base">Age</label>
                            <input
                                v-model="form.age"
                                v-validate="'required'"
                                name="age"
                                type="number"
                                placeholder="Enter your age"
                                :class="{ 'input input-block border-gray sm': true, 'is-invalid': errors.has('age') }"
                            />
                            <div class="invalid-feedback">
                                <span v-if="errors.has('age')" class="has-error shadow-text-none">{{
                                    errors.first('age')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="gender" class="input-label text-black text-left text-base">Gender</label>
                            <v-select
                                placeholder="Select your gender"
                                :options="genderList"
                                v-validate="'required'"
                                name="gender"
                                :class="{
                                    'input input-block border-gray sm': true,
                                    'is-invalid': errors.has('gender')
                                }"
                                v-model="form.gender"
                                autocomplete="off"
                            >
                                <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
                            </v-select>
                            <div class="invalid-feedback">
                                <span v-if="errors.has('gender')" class="has-error shadow-text-none">{{
                                    errors.first('gender')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="country" class="input-label text-black text-left text-base">Country</label>
                            <v-select
                                placeholder="Select your country"
                                label="name"
                                :options="countriesList"
                                :class="{
                                    'input input-block border-gray sm': true,
                                    'is-invalid': errors.has('country')
                                }"
                                name="country"
                                v-model="form.country"
                                v-validate="'required'"
                                autocomplete="off"
                            >
                                <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
                            </v-select>
                            <div class="invalid-feedback">
                                <span v-if="errors.has('country')" class="has-error shadow-text-none">{{
                                    errors.first('country')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="category" class="input-label text-black text-left text-base"
                                >Favourite category</label
                            >
                            <v-select
                                placeholder="Select your favourite category"
                                :options="categoryList"
                                :class="{
                                    'input input-block border-gray sm': true,
                                    'is-invalid': errors.has('category')
                                }"
                                name="category"
                                v-model="form.category"
                                v-validate="'required'"
                                autocomplete="off"
                            >
                                <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
                            </v-select>
                            <div class="invalid-feedback">
                                <span v-if="errors.has('category')" class="has-error shadow-text-none">{{
                                    errors.first('category')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="paypal_email" class="input-label text-black text-left text-base"
                                >PayPal account e-mail</label
                            >
                            <input
                                v-model="form.paypal"
                                v-validate="'required|email'"
                                name="paypal email"
                                type="email"
                                placeholder="Enter your Paypal's account email"
                                :class="{
                                    'input input-block border-gray sm': true,
                                    'is-invalid': errors.has('paypal email')
                                }"
                            />
                            <div class="invalid-feedback">
                                <span v-if="errors.has('paypal email')" class="has-error shadow-text-none">{{
                                    errors.first('paypal email')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="contact_email" class="input-label text-black text-left text-base"
                                >Contact e-mail</label
                            >
                            <input
                                v-model="form.email"
                                v-validate="'required|email'"
                                name="contact email"
                                type="email"
                                placeholder="Enter your contact email"
                                :class="{
                                    'input input-block border-gray sm': true,
                                    'is-invalid': errors.has('contact email')
                                }"
                            />
                            <div class="invalid-feedback">
                                <span v-if="errors.has('contact email')" class="has-error shadow-text-none">{{
                                    errors.first('contact email')
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group mb-5">
                            <button type="submit" class="btn font-opensans">Send Request</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import InnerLoader from '@/components/InnerLoader'
import datalist from '@/mixins/datalist'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import popup from '@/lib/popup'
import { isLoggedIn } from '@/lib/user'
import { load } from 'recaptcha-v3'
import { directive as onClickaway } from 'vue-clickaway'

export default {
    mixins: [datalist],

    directives: {
        onClickaway: onClickaway
    },

    components: {
        InnerLoader
    },

    watch: {
        'form.age': function (val) {
            if (parseFloat(val) < 0) {
                this.form.age = '0'
            }
        },
        isOpen: function () {
            this.form = {
                fullname: '',
                age: '',
                gender: '',
                category: '',
                country: '',
                paypal: '',
                email: ''
            }
        }
    },

    mounted() {
        const self = this
        const request = new Request()

        var payload = {
            type: 'category'
        }

        request
            .get(appConfig.api.getCategoryTags, {
                params: payload
            })
            .then(res => {
                if (res.data.status_code == 200) {
                    var result = res.data.data.data

                    result.forEach((item, index) => {
                        self.$set(self.categoryList, index, {
                            label: item.name,
                            code: item._id.$oid
                        })
                    })
                }
            })

        if (document.querySelector('#contributors-trigger')) {
            document.querySelector('#contributors-trigger').onclick = function () {
                if (!isLoggedIn()) {
                    self.$emit('required-login')
                    return
                } else {
                    self.getCurrentCountry()
                    self.$set(self, 'isOpen', true)
                }
            }
        }
    },

    data() {
        return {
            isOpen: false,
            isLoading: false,
            form: {
                fullname: '',
                age: '',
                gender: '',
                category: '',
                country: '',
                paypal: '',
                email: ''
            },
            categoryList: []
        }
    },

    methods: {
        submit() {
            this.$validator.validate().then(result => {
                if (result) {
                    this.isLoading = true
                    load(this.getRecaptchaSiteKey(), {
                        useRecaptchaNet: true,
                        autoHideBadge: true
                    }).then(async recaptcha => {
                        var token = await recaptcha.execute('validate_captcha', { action: 'validate_captcha' })
                        const request = new Request()

                        const payload = {
                            captcha_response: token,
                            subject: 'Apply to Contributor',
                            fullname: this.form.fullname,
                            age: this.form.age,
                            email: this.form.email,
                            paypal: this.form.paypal,
                            country: `${this.form.country.name}[${this.form.country.code}]`,
                            gender: this.form.gender.label,
                            category: this.form.category.label
                        }

                        request
                            .post(appConfig.api.sendContributor, payload)
                            .then(() => {
                                this.isLoading = false
                                popup.alert(
                                    'Your request sent! \n We will contact you as soon as possible.',
                                    () => {
                                        this.closeModal()
                                    },
                                    {
                                        icon: 'success'
                                    }
                                )
                            })
                            .catch(() => {
                                this.isLoading = true
                                popup.alert(
                                    'Something wrong..',
                                    () => {
                                        this.closeModal()
                                    },
                                    {
                                        icon: 'error'
                                    }
                                )
                            })
                    })
                }
            })
        },

        getRecaptchaSiteKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        closeModal() {
            if (this.isLoading == true) {
                return
            }
            this.isOpen = false
        },

        getCurrentCountry() {
            this.$store.dispatch('getCurrentCountry').then(res => {
                this.form.country = {
                    name: res.data.data.name,
                    code: res.data.data.code
                }
            })
        }
    }
}
</script>

<style lang="scss">
.contributor-modal {
    font-family: 'Open Sans', sans-serif !important;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: start;
    font-size: 1.2em;
    z-index: 9999;
    overflow-y: auto;

    .modal-content {
        background-color: #fff;
        margin-top: 1rem;
        padding: 1rem 1.5rem;
        width: 600px !important;
        // overflow: modal-close;
        border-radius: 3px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

        @media screen and (max-width: 500px) {
            width: 90% !important;
            margin: 1rem 0.5rem;
        }

        .modal-body {
            padding: 0.5rem 0;

            .vs__dropdown-menu {
                max-height: 150px;
                overflow-x: hidden;
            }

            input::placeholder,
            .vs__search {
                text-align: left;
                padding: 0;
            }

            .vs__search::placeholder {
                font-weight: bold;
                text-transform: uppercase;
                color: #adadad;
            }

            .vs__dropdown-toggle {
                padding: 0;
                border: 0;

                .vs__selected {
                    padding: 0;
                    border: 0;
                    margin: 0;
                    text-shadow: none;
                }
            }
        }

        .is-invalid {
            border-color: #ef0000 !important;
        }
    }

    .contributor-loading {
        margin: -1rem 0 0 -1.5rem;
    }

    .btn {
        font-size: 1rem;
    }

    .invalid-feedback {
        color: #ef0000;
        font-size: 0.7rem;
        text-align: left;
        margin-top: 0.4rem;
    }
}
</style>
